
import AnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class LandAnimateSymbolBehaviour extends AnimateSymbolBehaviour {

    public behaviourName: string = "LandAnimate";

    /**
     * Same as AnimateBehaviour except for landing
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAnimation="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win") {
        super(symbol, defaultAnimation);
    }

    public land(): Contract<void> {
        return this.animate("_land", ["land"], true);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }
}
